import React from "react";

export default function UploaderButton(props: any) {
  return (
    <a
      href="#"
      className="d-flex bg-blue1 align-self-stretch p-3 br-lg cta-box"
      onClick={() => props.onClick()}
    >
      <div className="align-self-center text-center">
        <span className="icon-upload fs-4"></span>
      </div>
      <div className="align-self-center">
        <p className="mb-0 fs-125 fw-400">
          Meine Rechnungen, Rezepte u. Belege
        </p>
        <p className="mb-0 fs-2 fw-500 ttup"> Einreichen</p>
      </div>
    </a>
  );
}
